'use client';

import { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface UIContextType {
  isMobileSimulatorEnabled: boolean;
  setMobileSimulatorEnabled: (_enabled: boolean) => void;
  isMobileMenuOpen: boolean;
  setMobileMenuOpen: (_open: boolean) => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

export function UIProvider({ children }: { children: ReactNode }) {
  const [isMobileSimulatorEnabled, setMobileSimulatorEnabled] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const value = useMemo<UIContextType>(() => ({
    isMobileSimulatorEnabled,
    setMobileSimulatorEnabled,
    isMobileMenuOpen,
    setMobileMenuOpen,
  }), [isMobileSimulatorEnabled, isMobileMenuOpen]);

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
}
